module.exports = __webpack_public_path__ + "img/pic_200215_3.16226ee5.jpg";